import FatFilterContainer from './FatFilterContainer'

export default FatFilterContainer
// eslint-disable-next-line import/export
export * from './FatFilterContainer'
